import React from 'react';
import { FiX } from 'react-icons/fi';

const TermsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-gray-900 rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden shadow-2xl">
        <div className="flex items-center justify-between p-6 border-b border-gray-700">
          <h2 className="text-2xl font-bold text-cyan-300">Terms & Conditions</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors p-2"
          >
            <FiX className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          <div className="space-y-6 text-gray-200">
            <section>
              <h3 className="text-xl font-semibold text-cyan-300 mb-3">1. Acceptance of Terms</h3>
              <p className="mb-4">
                Welcome to Gemini AI Trading. By accessing and using our platform, you agree to be bound by these Terms & Conditions. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-cyan-300 mb-3">2. Description of Service</h3>
              <p className="mb-4">
                Gemini AI Trading is an automated trading platform that utilizes artificial intelligence and machine learning algorithms to execute cryptocurrency trades. Our platform provides:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Automated trading strategies for various cryptocurrencies</li>
                <li>Real-time market analysis and price monitoring</li>
                <li>Portfolio management and performance tracking</li>
                <li>Educational resources and trading insights</li>
                <li>Secure account management and transaction processing</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-cyan-300 mb-3">3. User Eligibility</h3>
              <p className="mb-4">
                To use our services, you must:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Be at least 18 years old or of legal age in your jurisdiction</li>
                <li>Provide accurate and complete registration information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Comply with all applicable laws and regulations</li>
                <li>Not be a resident of a restricted jurisdiction</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-cyan-300 mb-3">4. Trading Risks</h3>
              <div className="bg-yellow-900/20 border border-yellow-500 rounded-lg p-4 mb-4">
                <p className="text-yellow-300 font-semibold">IMPORTANT RISK NOTICE</p>
                <p className="text-yellow-200 mt-2">
                  Trading cryptocurrencies involves substantial risk of loss and is not suitable for all investors. Past performance does not guarantee future results. You may lose some or all of your invested capital.
                </p>
              </div>
              <p className="mb-4">
                By using our platform, you acknowledge that cryptocurrency markets are highly volatile and you are solely responsible for your trading decisions.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-cyan-300 mb-3">5. Limitation of Liability</h3>
              <p className="mb-4">
                To the maximum extent permitted by law, Gemini AI Trading shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-cyan-300 mb-3">6. Contact Information</h3>
              <p className="mb-4">
                For questions about these terms, please contact our support team through the platform or at support@gemini-ai-trading.com.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
